import { MyAlerts } from "@/components/navigation/MyAlerts";

/**
 * My alerts as a page (#1271): what a watcher's email opens as Manage notifications. The same list
 * the user menu shows, the signed-in person's own watches in this instance with Stop beside each.
 * Every role opens it (`instance.read`), so a viewer who can watch can also stop watching.
 */
export default function MyAlertsPage() {
  return (
    <div className="flex max-w-2xl flex-col gap-4" data-testid="my-alerts-page">
      <MyAlerts placement="page" />
    </div>
  );
}
